var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AccordionCard',{staticClass:"fill-height",attrs:{"title":"Unassigned Jobs"}},[_c('UnassignedJobsList',{ref:"unassignedList"}),_c('DraftJobsList',{ref:"draftList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }